import React, {useRef, useEffect, useState} from 'react';

import {Typography} from '@mui/material';

import {ZmTooltip} from 'Components/ZmTooltip/ZmTooltip';

/**
 * Wrap the given text content in a tooltip that will only show when
 * the text content is overflowing out of its bounding container
 * @param {*} props
 * @param {String} props.content
 * @param {?String} props.placement
 * @param {?Number} props.lineClamp
 * @return {ReactElement}
 */
const OverflowTip = (props) => {
  const textElementRef = useRef();

  const RenderComponent = props.render || Typography;

  const compareSize = () => {
    try {
      const compare = textElementRef.current.scrollHeight > textElementRef.current.clientHeight ||
        textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
      setHover(compare);
    } catch {}
  };

  // compares and adds resize listener on mount
  useEffect(() => {
    compareSize();
    window.addEventListener('resize', compareSize);
    // cleanup resizer listener
    return () => window.removeEventListener('resize', compareSize);
  }, []);


  // Define state and function to update the value
  const [hoverStatus, setHover] = useState(false);

  return (
    <ZmTooltip
      title={props.content}
      placement={props.placement}
      disableHoverListener={!hoverStatus}
    >
      <RenderComponent
        component={'div'}
        ref={textElementRef}
        sx={{
          ...((props?.lineClamp > 1) ? {
            display: '-webkit-box',
            WebkitLineClamp: props?.lineClamp,
            WebkitBoxOrient: 'vertical',
            lineBreak: 'auto',
            wordBreak: 'normal',
            overflowWrap: 'anywhere',
          } : {
            whiteSpace: 'nowrap',
          }),
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          ...props.sx,
        }}
      >
        {props.content}
      </RenderComponent>
    </ZmTooltip>
  );
};

export default OverflowTip;
